import api from '@/js/services/api';
export default {

    getEmployeeListOfRequests(applicantId, filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get(`/applicant/${applicantId}/uniform/requests/get?` + searchParams.toString())
    },

    sendNewRequest(applicantId, request) {
        return api().post(`/applicant/${applicantId}/uniform/request/store`, {request})
    },
    getUniformsListForApplicant() {
        return api().get('/applicant/get/uniforms/list');
    },
    searchUniformInList(search) {
        return api().get('/applicant/get/uniforms/list', {
            params: {
                search: search,
                withoutPagination: true,
                sortBy: 'title',
                sortDir: 'asc'
            }
        });
    },

    getReturnedUniforms(applicantId, filters) {
        const searchParams = new URLSearchParams();

        for (const [key, value] of Object.entries(filters)) {
            searchParams.append(key, value)
        }

        return api().get(`/applicant/${applicantId}/uniform/returned-requests/get?` + searchParams.toString())
    }



}
